import { Component } from '@angular/core';

@Component({
  selector: 'splash',
  templateUrl: './Splash.html',
  styleUrl: './Splash.css',
  standalone: true,
})
export class Splash {

}
